<template>
    <div v-if="session">
        <top-navbar :breadcrumb="$route.params.groupId != 0 ? groupBreadcrumb : cohortBreadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="d-none d-lg-block col-lg-4">

                    <learners
                        :session="session"
                        :registration="registration"
                        :simulation="simulation"
                        :groups="groups"
                        @openCohort="openCohort"
                        @openGroup="openGroup">
                    </learners>

                    <status v-model="session" :mustSendIssues="mustSendIssues"
                        @openIssues="openIssues"
                    >
                    </status>
                </div>
                <div class="col-lg-8">
                    <session ref="session"
                        :session="session"
                        :registration="registration"
                        :simulation="simulation"
                        :groups="groups"
                        :competencies="competencies">
                    </session>

                    <div class="d-lg-none">

                        <learners :compact="true"
                            :session="session"
                            :registration="registration"
                            :simulation="simulation"
                            :groups="groups"
                            @openCohort="openCohort"
                            @openGroup="openGroup">
                        </learners>

                        <status v-model="session" :mustSendIssues="mustSendIssues" :compact="true"
                            @openIssues="openIssues"
                        >
                        </status>
                    </div>

                    <tabs class="tabs" ref="session-tabs"
                            tabNavClasses="nav-fill flex-column flex-sm-row nav-wrapper pb-3"
                            tabContentClasses="">

                        <tab-pane class="mb-0" id="notes">
                            <span slot="title">
                                {{ $t('dashboard.personal-notes') }}
                            </span>
                            <feedbacks
                                :registration="registration"
                                :simulation="simulation"
                                 v-model="session"
                                :competencies="competencies"
                                :edit="session.closed_at == null"
                                :sharing="true"
                                @createIssue="$refs.issues.createInTimeslot($event)"
                                @sharedFeedbacks="$refs.session.setSharedFeedbacks($event)"
                            >
                            </feedbacks>
                        </tab-pane>

                        <tab-pane class="card mb-0" id="issues" v-if="!simulation.remedial">
                            <span slot="title">
                                {{ $t('common.issues') }}
                            </span>
                            <issues v-model="session"
                                :edit="session.closed_at == null"
                                :registration="registration"
                                :simulation="simulation"
                                role="instructor"
                                @mustSendIssues="mustSendIssues = $event"
                                ref="issues">
                            </issues>
                        </tab-pane>
                    </tabs>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Session from './session/Session'
    import Learners from './session/Learners'
    import Feedbacks from './common/Feedbacks'
    import Issues from './session/Issues'
    import Status from './session/Status'

    export default {

        components: {
            Session, Learners, Feedbacks, Issues, Status
        },

        data() {
            return {
                session: null,
                registration: null,
                simulation: null,
                groups: null,
                competencies: null,
                mustSendIssues: false,
            }
        },

        computed: {

            groupBreadcrumb() {
                return [
                    {
                        name: this.registration.cohort.name,
                        route: '/astral/ui/dashboard/cohorts/' + this.registration.cohort.id
                    },
                    {
                        name: this.registration.degree.name,
                        route: '/astral/ui/dashboard/registrations/' + this.$route.params.registrationId + '/groups/' + this.$route.params.groupId
                    },
                    {
                        name: this.simulation.name,
                        route: '/astral/ui/dashboard/registrations/' + this.$route.params.registrationId + '/simulations/' + this.$route.params.simulationId + '/groups/' + this.$route.params.groupId
                    },
                    {
                        name: this.$t('common.session'),
                    },
                ]
            },

            cohortBreadcrumb() {
                return [
                    {
                        name: this.registration.cohort.name,
                        route: '/astral/ui/dashboard/cohorts/' + this.registration.cohort.id
                    },
                    {
                        name: this.registration.degree.name,
                        route: '/astral/ui/dashboard/registrations/' + this.$route.params.registrationId + '/cohorts/' + this.registration.cohort.id
                    },
                    {
                        name: this.simulation.name,
                        route: '/astral/ui/dashboard/registrations/' + this.$route.params.registrationId + '/simulations/' + this.$route.params.simulationId + '/cohorts/' + this.registration.cohort.id
                    },
                    {
                        name: this.$t('common.session'),
                    },
                ]
            }
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/astral/api/front/dashboard/sessions/'+to.params.sessionId, { params: {
                groups: true
            }})
            .then(resp => {
                next(vm => {
                    vm.session = resp.data.data
                    vm.registration = resp.data.included.registration
                    vm.simulation = resp.data.included.simulation
                    vm.groups = resp.data.included.groups
                    vm.competencies = resp.data.included.competencies
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.$loader.hide()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                }
            });
        },

        methods: {

            openIssues() {
                if (!this.simulation.remedial) {
                    this.$refs['session-tabs'].findAndActivateTab('issues')
                }
            },

            openCohort() {
                this.$router.push({
                    name: 'dashboard-cohort-simulation',
                    params: {
                        registrationId: this.registration.id,
                        simulationId: this.simulation.id,
                        cohortId: this.registration.cohort.id,
                    }
                });
            },

            openGroup() {
                this.$router.push({
                    name: 'dashboard-group-simulation',
                    params: {
                        registrationId: this.registration.id,
                        simulationId: this.simulation.id,
                        groupId: this.groups[0].id,
                    }
                });
            },
        }
    }
</script>

<style scoped>

    .tabs >>> .nav-pills {
        padding-top: 0;
        padding-bottom: 1.5rem;
    }

</style>
